const sameValue = (x, y) => x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));

const includes = (array, searchElement) => array.some((element) => sameValue(element, searchElement));

export default includes;
